import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Vue from 'vue';
import universityBranding from '~/mixins/universityBranding';
export default Vue.extend({
  name: 'SimpleLayout',
  mixins: [universityBranding],
  computed: {
    isFaq: function isFaq() {
      return this.$router.currentRoute.path === 'faqs';
    }
  },
  methods: {
    logout: function logout() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch('login/logout').then(function (response) {
                  _this.$toast.success('Successfully logged out!');

                  _this.$router.push(_this.localePath({
                    path: '/login'
                  }));
                }).catch(function (error) {
                  console.error(error);
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    goToFaq: function goToFaq() {
      this.$router.push(this.localePath({
        path: '/faqs'
      }));
    }
  }
});